const ErrorGenerator = ({ shouldThrow }: any) => {
  if (shouldThrow) {
    throw new Error("Intentional error for testing ErrorBoundary.");
  }

  return null; // or return a valid JSX element if shouldThrow is false
};

export default ErrorGenerator;
